import React, { useState } from "react";
import DownloadTransactionPDF from "../../../components/Table/DownloadTransactionPDF";

function TransactionTransactionsSearchSection({
  search,
  setSearch,
  timeFilter,
  setTimeFilter,
}) {
  const [loading, setLoading] = useState(false);
  // const handleExport = () => {};

  return (
    <div className="w-full justify-between items-center mt-4 pt-4 border-t border-gray-300 flex">
      <div className="flex flex-1 w-full flex-shrink-0 h-12 py-3 md:py-0 rounded-lg items-center border-2 border-[#DBDBDB] px-4 gap-3 max-w-[600px]">
        <input
          type="text"
          value={search}
          className="flex flex-1 text-sm font-main"
          onChange={(e) => setSearch(e.target.value)}
          placeholder={"Search for transaction"}
        />
        <img src="/IconSearch1.svg" alt="" />
      </div>
      <DownloadTransactionPDF />
      {/* <div className="flex gap-2 items-center">
        <Button1
          variant="text"
          className="capitalize !w-auto"
          onClick={handleExport}
        >
          Export
        </Button1>
        <div className="flex gap-2 items-center light-bg rounded-md p-2">
          <SelectInput
            defaultValue="Weekly"
            size="small"
            label=""
            value={timeFilter?.range}
            onChange={(ev) =>
              setTimeFilter({ ...timeFilter, range: ev.target.value })
            }
          >
            <MenuItem value="hour">Hourly</MenuItem>
            <MenuItem value="day">Daily</MenuItem>
            <MenuItem value="week">Weekly</MenuItem>
            <MenuItem value="month">Monthly</MenuItem>
            <MenuItem value="year">Yearly</MenuItem>
            <MenuItem value="all">All</MenuItem>
          </SelectInput>
          <CalendarInput1
            value={timeFilter?.date}
            onChange={(obj) =>
              setTimeFilter({ ...timeFilter, date: obj?.start })
            }
          />
        </div>
      </div> */}
    </div>
  );
}

export default TransactionTransactionsSearchSection;
